import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';
import DummyContent from '../primitive/DummyContent';

interface Props {
  className?: string;
}

const ProjectTypeDetail = ({ className }: ClassAttributes<HTMLElement> & Props) => (
  <div className={className}>
    <Title size="h6" />

    <Heading variant="subtitle1">
      <FormattedMessage id="project_type_detail.expected_time_to_delivery" />
    </Heading>

    <Description size="body2" length={175} />

    <Heading variant="subtitle1">
      <FormattedMessage id="project_type_detail.creative_format" />
    </Heading>

    <Description size="body2" length={175} />

    <Heading variant="subtitle1">
      <FormattedMessage id="project_type_detail.things_you_need" />
    </Heading>

    <Description size="body2" length={175} />
  </div>
);

const Title = styled(DummyContent)({ marginBottom: SPACING_REGULAR });

const Heading = styled(Typography)({ marginBottom: SPACING_UNIT / 2 });

const Description = styled(DummyContent)({
  marginBottom: SPACING_REGULAR,
  ':last-child': {
    marginBottom: 0,
  },
});

export default ProjectTypeDetail;
